import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SamlService } from '../services/saml.service';

@Component({
  selector: 'app-saml-login',
  templateUrl: './saml-login.component.html',
  styleUrls: ['./saml-login.component.css'],
  standalone: true,
  imports: [RouterLink]
})
export class SamlLoginComponent implements OnInit {

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly samlService: SamlService,
    private readonly router: Router,
    ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.token) {
        localStorage.removeItem('SamlToken');
        localStorage.setItem('tempToken', params.token);
      }
    });
  }

  ngOnInit() {
    this.getSamlToken();
  }

  async getSamlToken() {
    
    const param = { referrer: document.referrer };
    try {
      // Wait for the getToken() method to return data using await.
      const data: any = await this.getTokenWithDelay(param);
  
      localStorage.removeItem('tempToken');
  
      if (data) {
        localStorage.setItem('SamlToken', data.token);
        this.router.navigate(['portal/home']);
      } else {
        this.router.navigate(['register']);
      }
    } catch (error) {
      console.log('Error while fetching SAML token:', error);
    }
  }
   delay(ms: number) {
    return new Promise<void>((resolve) => setTimeout(resolve, ms));
  }
  
  async getTokenWithDelay(param: any) {
    try {
      const data: any = await this.samlService.getToken(param).toPromise();
      await this.delay(1000);
      return data;
    } catch (error) {
      console.log(error);
    }
  }
  


}
